const procesoRouter = [
  {
    path: "/solicitudes/proceso",
    name: "proceso",
    meta: {
      requiredRoles: "ROLE_RENUNCIA_EMPLEADO_LISTAR_PROCESO",
    },
    component: () => import(/* webpackChunkName: "renuncias" */ "./listadoProcesos.vue"),
  }

];

export default procesoRouter;